import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ComprobantesEmitidos from "@/pages/ComprobantesEmitidos";
import ComprobantesRecibidos from "@/pages/ComprobantesRecibidos";
import Configuracion from "@/pages/Configuracion";
import ConfiguracionNCF from "@/pages/ConfiguracionNCF";
import { Toaster } from "@/components/ui/sonner";
import AxiosDB from "./Config/AxiosDB";
import Reportes from "./pages/Reportes";
import AdminEmpresas from "./pages/AdminEmpresas";
import Facturacion from "./pages/Facturacion";
import ReporteImpuesto from "./pages/ReporteImpuesto";
import Autologin from "./pages/Autologin";

export const API = '';


function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isImpersonating, setIsImpersonating] = useState(false);

  useEffect(() => {
    checkAuth();
    // Verificar si está en modo impersonate
    const impersonating = localStorage.getItem("impersonating") === "true";
    setIsImpersonating(impersonating);
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const response = await AxiosDB.get(`/auth/me`);
        setUser(response.data);
        setIsAuthenticated(true);
        console.log(response.data)
      } catch (error) {
        localStorage.removeItem("token");
        setIsAuthenticated(false);
      }
    }
    setLoading(false);
  };

  const handleLogin = (token, userData) => {
    localStorage.setItem("token", token);
    setUser(userData);
    setIsAuthenticated(true);
  };

  const handleImpersonate = (token, userData) => {
    localStorage.setItem("token", token);
    setUser(userData);
    setIsAuthenticated(true);
    setIsImpersonating(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("impersonating");
    localStorage.removeItem("superadmin_name");
    setUser(null);
    setIsAuthenticated(false);
    setIsImpersonating(false);
  };


  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
        <div className="text-lg text-slate-600">Cargando...</div>
      </div>
    );
  }

  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/autologin" element={<Autologin onLogin={handleLogin} />} />

          <Route
            path="/login"
            element={
              !isAuthenticated ? (
                <Login onLogin={handleLogin} />
              ) : (
                <Navigate to="/" replace />
              )
            }
          />
          <Route
            path="/"
            element={
              isAuthenticated ? (
                <Dashboard user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/emitidos"
            element={
              isAuthenticated ? (
                <ComprobantesEmitidos user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/recibidos"
            element={
              isAuthenticated ? (
                <ComprobantesRecibidos user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/configuracion"
            element={
              isAuthenticated ? (
                <Configuracion user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/configuracion-ncf"
            element={
              isAuthenticated ? (
                <ConfiguracionNCF user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/reporte-impuesto"
            element={
              isAuthenticated ? (
                <ReporteImpuesto user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/reportes"
            element={
              isAuthenticated ? (
                <Reportes user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/facturacion"
            element={
              isAuthenticated ? (
                <Facturacion user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/admin/empresas"
            element={
              isAuthenticated && user?.role === "superadmin" ? (
                <AdminEmpresas user={user} onLogout={handleLogout} onImpersonate={handleImpersonate} />
              ) : isAuthenticated ? (
                <Navigate to="/" replace />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;